import useJwt from '@/auth/jwt/useJwt'

export default class ProductService {
  // eslint-disable-next-line class-methods-use-this
  list() {
    return useJwt.get('/products')
  }
}
